import EventTasks from './EventTasks'

export default EventTasks
